import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { Home, User, Mail } from 'lucide-react';
// Helper for class names if not already available
function classNames(...classes: (string | undefined | null | false)[]) {
  return classes.filter(Boolean).join(' ');
}
const navItems = [{
  name: 'Ana Sayfa',
  url: '/',
  icon: Home
}, {
  name: 'Hakkımızda',
  url: '/hakkimizda',
  icon: User
}, {
  name: 'İletişim',
  url: '/iletisim',
  icon: Mail
}];
export function FloatingNav({
  className
}: {
  className?: string;
}) {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.pathname);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    // Update active tab based on current path
    const currentPath = location.pathname;
    const matchedItem = navItems.find(item => item.url === currentPath || item.url !== '/' && currentPath.startsWith(item.url));
    if (matchedItem) {
      setActiveTab(matchedItem.url);
    } else if (currentPath === '/') {
      setActiveTab('/');
    }
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [location]);
  return <>
      {/* Fixed Logo - Top Left */}
      <div className="fixed top-6 left-6 z-50" data-id="element-109">
        <Link to="/" className="text-xl font-bold tracking-wider text-white" data-id="element-110">
          VISION<span className="text-neon-cyan" data-id="element-111">PLUS</span>
        </Link>
      </div>

      {/* Floating Dock Navigation - Top on Desktop, Bottom on Mobile */}
      <div className={classNames('fixed left-1/2 -translate-x-1/2 z-50', 'bottom-6 md:bottom-auto md:top-6', className)} data-id="element-112">
        <div className="flex items-center gap-1 bg-white/10 border border-white/20 backdrop-blur-xl py-2 px-2 rounded-full shadow-2xl shadow-neon-cyan/10" data-id="element-113">
          {navItems.map(item => {
          const Icon = item.icon;
          const isActive = activeTab === item.url;
          return <Link key={item.name} to={item.url} onClick={() => setActiveTab(item.url)} className={classNames('relative cursor-pointer text-sm font-medium px-6 py-2.5 rounded-full transition-colors duration-300', isActive ? 'text-neon-cyan' : 'text-gray-400 hover:text-white')} data-id="element-114">
                <span className="hidden md:inline" data-id="element-115">{item.name}</span>
                <span className="md:hidden" data-id="element-116">
                  <Icon size={20} strokeWidth={2} data-id="element-117" />
                </span>

                {isActive && <motion.div layoutId="lamp" className="absolute inset-0 w-full bg-neon-cyan/5 rounded-full -z-10" initial={false} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-118">
                    {/* Lamp glow - position above on desktop, below on mobile */}
                    <div className={classNames('absolute left-1/2 -translate-x-1/2 w-8 h-1 bg-neon-cyan rounded-full', 'md:-top-2 md:rounded-t-full', '-bottom-2 md:bottom-auto rounded-b-full md:rounded-b-none')} data-id="element-119">
                      <div className="absolute w-12 h-6 bg-neon-cyan/20 rounded-full blur-md -left-2 md:-top-2 -bottom-2 md:bottom-auto" data-id="element-120" />
                      <div className="absolute w-8 h-6 bg-neon-cyan/20 rounded-full blur-md md:-top-1 -bottom-1 md:bottom-auto" data-id="element-121" />
                      <div className="absolute w-4 h-4 bg-neon-cyan/20 rounded-full blur-sm left-2 md:top-0 bottom-0 md:bottom-auto" data-id="element-122" />
                    </div>
                  </motion.div>}
              </Link>;
        })}
        </div>
      </div>
    </>;
}